<template>
  <div class="quick-navigation">
    <div class="app-container d-flex">
      <div class="quick-navigation_wrap">
        <a
          v-for="(item, i) in items"
          :key="`qn-${i}`"
          :href="item.link"
          class="quick-navigation_link"
          >{{ item.title }}</a
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "QuickNavigation",
  props: {
    items: {
      type: [Array, null],
      default: () => []
    }
  }
};
</script>

<style lang="scss">
@import "QuickNavigation";
</style>
